import getDashedTitle from './getDashedTitle';
import constants from './constants';

const typesWithTabs = [constants.memberRouteName, constants.epicRoute.path, constants.projectSlug];

const generateLink = (type, teamSlug, sourceId = '', title = '', tabName = 'boards') => {
  const baseUrl = `${window.location.origin}/${teamSlug}/${type}`;

  let url = baseUrl;
  if (sourceId) url += `-${sourceId}`;
  if (title) url += `-${getDashedTitle(title)}`;
  if (typesWithTabs.includes(type) && tabName) url += `/${tabName}`;
  return url;
};

export default generateLink;
